/**
 * A jump the reader asked for (e.g. "Show 10 more" landing on the rows it
 * revealed), announced from the element about to be scrolled into view. The
 * event bubbles to whichever scroller owns that element: a timeline that
 * follows its own live edge treats the programmatic scroll that follows like
 * the reader's own scrolling, so it stops following unless the jump lands on
 * that edge, instead of snapping back to the bottom on its next growth.
 */
export const READER_SCROLL_INTENT_EVENT = 'reader_scroll_intent';

export const announceReaderScrollIntent = (element: HTMLElement): void => {
  element.dispatchEvent(new window.Event(READER_SCROLL_INTENT_EVENT, { bubbles: true }));
};
